const TYPES = {
  SET_IS_OPEN: 'set-is-open',
};

export default TYPES;
